// Object declaration splitter preserving nested expression scopes.
// Example: "a: fn(1;2); b: 3;" -> ["a: fn(1;2)", " b: 3"].

// Split `a:b; c:d;` text while preserving nested function/bracket syntax.
export function splitTopLevelDeclarations(input: string): string[] {
  const parts: string[] = []
  let depthParen = 0
  let depthBracket = 0
  let current = ''

  // Walk characters to split by ';' only at top level.
  for (let i = 0; i < input.length; i += 1) {
    const ch = input[i]

    // Track nested function depth to avoid splitting inside (...) values.
    if (ch === '(') {
      depthParen += 1
      // Decrease function depth when a matching ')' is reached.
    } else if (ch === ')' && depthParen > 0) {
      depthParen -= 1
      // Track bracket depth for values like calc()[...] patterns.
    } else if (ch === '[') {
      depthBracket += 1
      // Decrease bracket depth when a matching ']' is reached.
    } else if (ch === ']' && depthBracket > 0) {
      depthBracket -= 1
    } else {
      // Keep depth counters unchanged for other chars.
    }

    // Split declaration only when ';' is outside nested scopes.
    if (ch === ';' && depthParen === 0 && depthBracket === 0) {
      parts.push(current)
      current = ''
      continue
    } else {
      // Keep collecting declaration text.
    }

    current += ch
  }

  // Push trailing content when any declaration text remains.
  if (current.trim()) {
    parts.push(current)
  } else {
    // Keep parts unchanged when trailing token is empty.
  }

  // Return declaration chunks split at top-level semicolons.
  return parts
}
